import { render, staticRenderFns } from "./Matieres.vue?vue&type=template&id=3e5488ae&"
import script from "./Matieres.vue?vue&type=script&lang=js&"
export * from "./Matieres.vue?vue&type=script&lang=js&"
import style0 from "./Matieres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports